<span class="budget-redirect-inline">
    <a mat-button
       linkButton
       [disableRipple]="true"
       [routerLink]="url"
       (click)="onNavigate()">
        {{ label }}
        <mat-icon svgIcon="icon-v2:arrow-right" class="budget-redirect-arrow"></mat-icon>
    </a>
    <span *ngIf="helperText" class="budget-redirect-helper">
        {{ helperText }}
    </span>
</span>
